






































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { GetLeftCategory, AddShiti } from "@/request/storehouse";
import { GetDaohang } from "@/request/schema";
import { GetSechemaList } from "@/request/mark";
import { PatchConceptualEntity } from "@/request/common";
@Component({
  components: {},
})
export default class Name extends Vue {
  @Prop()
  private task_id:any;// 任务id，如果父组件有传值，则需要在新增的时候发这个参数
  @Prop({ default: true })
  private showName: any; // 允许显示名称,默认true
  @Prop()
  private editName: any; // 允许修改名称
  @Prop({ default: true })
  private showYuyileixing: any; // 允许显示语义类型,默认true
  @Prop()
  private editYuyileixing: any; // 允许修改语义类型
  @Prop({ default: true })
  private showShangweigainian: any; // 允许显示上位概念,默认true
  @Prop()
  private editShangweigainian: any; // 允许修改上位概念
  @Prop()
  private shitiData: any; // {id:'',上位概念:[{id:"66ce8debe0a3700179f83fe5",name: "传染病与寄生虫病"}]}
  @Watch("shitiData")
  private shitiDataChange(val: any) {
    console.log("实体数据");
    console.log(val);
  }
  @Prop()
  private yuyiData: any; //{"label": "中医疾病","域名称": "中医疾病","_id": "T0049","域id": "T0049"}
  @Watch("yuyiData")
  private yuyiDataChange(val: any) {
    console.log("语义类型数据");
    console.log(val);
  }
  @Prop()
  private ifShow: any;
  @Watch("ifShow")
  private ifShowChange(val: any) {
    this.ifShowEdit = val;
    this.editData = {};
    if (val) {
      if (this.shitiData && this.shitiData.id) {
        this.editData["名称"] = this.shitiData["实体名称"];
        this.editData.id = this.shitiData.id;
      }
      if (this.editYuyileixing) {
        this.getNav();
      }
      if (this.yuyiData && this.yuyiData._id) {
        this.editData["语义类型"] = JSON.parse(JSON.stringify(this.yuyiData));
        this.selectYuyi();
        if (this.editShangweigainian) {
          this.getTypes();
        }
      } else {
        this.editData["语义类型"] = {};
      }
      if (
        this.shitiData &&
        this.shitiData["上位概念"] &&
        this.shitiData["上位概念"].length > 0
      ) {
        this.editData["上位概念"] = JSON.parse(JSON.stringify(this.shitiData["上位概念"]));
        this.selectGainian();
      } else {
        this.editData["上位概念"] = [];
      }
    }
  }
  private ifShowEdit: boolean = false;
  private editData: any = {};
  private yuyileixingList: any = [];
  private yuyiNav: any = [];
  private props: any = {
    label: "name",
  };
  private fenleiData: any = [];
  private defaultProps: any = {
    label: "域名称",
  };
  private treeKey: number = Date.now();
  private removeGainian(item: any, index: number) {
    // 从数组中删除指定索引的上位概念
    this.editData['上位概念'].splice(index, 1);

    // 取消树形控件中对应节点的选中状态
    this.$nextTick(() => {
      const tree = this.$refs.optTree as any;
      if (tree) {
        tree.setChecked(item.id, false);
      }
    });
  }
  private handleYuyiNodeClick(data: any, node: any) {
    this.editData["语义类型"] = node.data;
    this.$forceUpdate();
    this.editData["上位概念"] = [];
    if (this.editShangweigainian) {
      this.getTypes();
      this.treeKey = Date.now();
    }
  }
  private selectYuyi() {
    // 如果this.editData['语义类型']存在，则选中
    if (this.editData["语义类型"] && this.editData["语义类型"]["域id"]) {
      this.$nextTick(() => {
        const tree = this.$refs.yuyiTree as any;
        if (tree) {
          tree.setCurrentKey(this.editData["语义类型"]["域id"]);
        }
      });
    }
  }
  private selectGainian() {
    // 如果this.editData['上位概念']存在，则选中
    if (this.editData["上位概念"] && this.editData["上位概念"].length > 0) {
      this.$nextTick(() => {
        const tree = this.$refs.optTree as any;
        const checkedKeys = this.editData["上位概念"].map(
          (item: any) => item.id
        );
        tree.setCheckedKeys(checkedKeys);
      });
    }
  }
  // 获取语义类型选项
  private getNav() {
    return new Promise((resolve, reject) => {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      const params: any = {
        params: {
          type: "语义类型",
        },
      };
      GetDaohang(this, params, loading).then((res: any) => {
        loading.close();
        this.yuyiNav = res;
        this.selectYuyi();
        resolve(res);
      });
    });
  }
  private handleCheckChange(data: any, checked: any, indeterminate: any) {
    // 手动维护 editData["上位概念"]，只增删当前节点
    const idx = this.editData["上位概念"].findIndex((item: any) => item.id === data.id);
    if (checked && idx === -1) {
      this.editData["上位概念"].push(data);
    } else if (!checked && idx !== -1) {
      this.editData["上位概念"].splice(idx, 1);
    }
    this.$forceUpdate();
  }
  private leixingChange(item: any) {
    this.editData["语义类型"] = {
      _id: item._id,
      域id: item._id,
      域名称: item.label,
      label: item.label,
      color: item.color,
    };
    this.editData["上位概念"] = [];
    this.selectYuyi();
    this.$forceUpdate();
    this.getTypes();
    this.treeKey = Date.now();
  }

  // 获取概念实体选项
  private getTypes() {
    const params: any = {
      params: {
        _id: "",
        语义id: this.editData["语义类型"]["域id"],
      },
    };
    GetLeftCategory(this, params).then((res: any) => {
      this.fenleiData = res;
      this.$forceUpdate();
      this.selectGainian();
      this.treeKey = Date.now();
    });
  }
  private searchYuyiOptions(e: any) {
    const params: any = {
      params: {
        search: e,
        type: "语义类型",
      },
    };
    GetSechemaList(this, params).then((data: any) => {
      this.yuyileixingList = data;
    });
  }
  private loadNode(node: any, resolve: any) {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        _id: node.data ? node.data._id : "",
        语义id: this.editData["语义类型"]["域id"],
      },
    };
    GetLeftCategory(this, params, loading)
      .then((res: any) => {
        loading.close();
        // 禁用与自己 id 相同的节点
        if (this.shitiData && this.shitiData.id) {
          res.forEach((node: any) => {
            if (node.id === this.shitiData.id) {
              node.disabled = true;
            }
          });
        }
        resolve(res);
        // 只有在根节点加载时才去选中
        if (
          node.level === 0 &&
          this.editData["上位概念"] &&
          this.editData["上位概念"].length > 0
        ) {
          this.$nextTick(() => {
            const tree = this.$refs.optTree as any;
            const checkedKeys = this.editData["上位概念"].map(
              (item: any) => item.id
            );
            tree.setCheckedKeys(checkedKeys);
          });
        }
      })
      .catch(() => {
        loading.close();
        resolve([]);
      });
  }
  private cancel() {
    this.ifShowEdit = false;
    this.$emit("cancel");
    // 重置 editData，避免下次打开残留
    this.editData = {
      名称: "",
      语义类型: {},
      上位概念: [],
      id: undefined
    };
  }
  private makeSure() {
    if (this.shitiData && this.shitiData.id) {
      // 编辑
      this.editSure();
    } else {
      // 新增
      this.addSure();
    }
  }
  private addSure() {
    if (!this.editData["语义类型"] || !this.editData["语义类型"]["域id"]) {
      this.$message.warning("请选择语义类型");
      return;
    }
    if (!this.editData["名称"]) {
      this.$message.warning("请输入实体名称");
      return;
    }
    const params: any = {
      上位概念: this.editData["上位概念"],
      语义id: this.editData["语义类型"]["域id"],
      实体名称: this.editData["名称"],
    };
    if(this.task_id){
      params.created_task_id  = this.task_id
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    AddShiti(this, params, loading).then((res: any) => {
      loading.close();
      this.$message.success("添加成功");
      this.$emit("addSure", res);
    }).catch(() => {
      loading.close();
    });
  }
  private editSure() {
    if (!this.editData["语义类型"] || !this.editData["语义类型"]["域id"]) {
      this.$message.warning("请选择语义类型");
      return;
    }
    // 编辑
    const params: any = {
      语义类型: this.editData["语义类型"].label,
      上位概念: this.editData["上位概念"],
    };
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    PatchConceptualEntity(this, this.shitiData.id, params, loading).then(
      (res: any) => {
        loading.close();
        this.$message.success("修改成功");
        this.$emit("editSure", res);
      }
    );
  }
}
